import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { productSoreList, CompanyDataAnalysisOptions, defaultChartOrTableHeight, makeConcurrencyUserDetailsTableRows, makeKickedOutUserDetailTableRows } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import _ from 'lodash';
import { CompanyDataAnalysisDataSet, CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import { productColor, searchColor } from './echartsOption';
import { GoodTableColumnFixedType } from '@/components/GoodTable/GoodTable.types';
export const NEW_COMMON_USER = 'newCommonUserPermissionChart';
export const CONCURRENCY_PV_ANALYSIS = 'concurrencyPvAnalysis';
export const CONCURRENCY_UV_ANALYSIS = 'concurrencyUvAnalysis';
export const KICKED_OUT_BY_SELF_ANALYSIS = 'kickedOutBySelfAnalysis';
export const KICKED_OUT_BY_OTHERS_ANALYSIS = 'kickedOutByOthersAnalysis';
let CompanyUserDataAnalysisService = class CompanyUserDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, companyQueriesService, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.companyQueriesService = companyQueriesService;
        this.i18n = i18n;
        /**
         * 并发配置 - PV
         */
        this.instancesPvAnalysisOption = new CompanyDataAnalysisOptions();
        /**
         * 并发配置 - UV
         */
        this.instancesUvAnalysisOption = new CompanyDataAnalysisOptions();
        this.concurrencyUserDetailsOption = new CompanyDataAnalysisOptions();
        // 新增用户配置
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        /**
         * 被自己踢出配置
         */
        this.kickedOutBySelfOption = new CompanyDataAnalysisOptions();
        /**
         * 被他人踢出配置
         */
        this.kickedOutByOthersOption = new CompanyDataAnalysisOptions();
        this.kickedOutUserDetailOption = new CompanyDataAnalysisOptions();
        this.concurrencyPvConfigInit();
        this.concurrencyUvConfigInit();
        this.concurrencyUserDetailsConfigInit();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
        this.kickedOutBySelfConfigInit();
        this.kickedOutByOthersConfigInit();
        this.kickedOutUserDetailConfigInit();
    }
    async getConcurrencyPvUvTableColumns(packages) {
        const baseColumns = [
            { label: this.i18n.t('backoffice.company.dataAnalysis.date'), field: CompanyDataAnalysisEventKey.DATE, width: '120px', fixed: GoodTableColumnFixedType.LEFT }
        ];
        if (!packages || Object.keys(packages).length === 0) {
            return _.compact(baseColumns);
        }
        // 获取所有packages
        const packagesList = await this.companyQueriesService.getPackages();
        const packageMap = _.keyBy(packagesList, 'id');
        // 从packages对象中提取所有的package keys
        const packageKeys = Object.keys(packages);
        // 为每个package key生成column
        const packageColumns = packageKeys.map(packageKey => {
            const packageInfo = packageMap[packageKey];
            const label = packageInfo ? this.companyQueriesService.getPackageName(packageInfo) : packageKey;
            return {
                label,
                field: packageKey,
            };
        });
        console.log(packageColumns);
        return _.compact([...baseColumns, ...packageColumns]);
    }
    concurrencyPvConfigInit() {
        this.instancesPvAnalysisOption.reportName = CompanyDataAnalysisKeyType.CONCURRENCY;
        this.instancesPvAnalysisOption.title = this.i18n.t('backoffice.company.dataAnalysis.userConcurrencyPv');
        this.instancesPvAnalysisOption.canCollapse = false;
        this.instancesPvAnalysisOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.instancesPvAnalysisOption.canChangeViewType = true;
        // 初始化空的columns，后续会在getConcurrencyData中动态设置
        this.instancesPvAnalysisOption.tableOptions.columns = [];
        this.instancesPvAnalysisOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.instancesPvAnalysisOption.chartId = CONCURRENCY_PV_ANALYSIS;
        this.instancesPvAnalysisOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    concurrencyUvConfigInit() {
        this.instancesUvAnalysisOption.reportName = CompanyDataAnalysisKeyType.CONCURRENCY;
        this.instancesUvAnalysisOption.title = this.i18n.t('backoffice.company.dataAnalysis.userConcurrencyUv');
        this.instancesUvAnalysisOption.canCollapse = false;
        this.instancesUvAnalysisOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.instancesUvAnalysisOption.canChangeViewType = true;
        // 初始化空的columns，后续会在getConcurrencyData中动态设置
        this.instancesUvAnalysisOption.tableOptions.columns = [];
        this.instancesUvAnalysisOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.instancesUvAnalysisOption.chartId = CONCURRENCY_UV_ANALYSIS;
        this.instancesUvAnalysisOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getConcurrencyData(params) {
        this.instancesPvAnalysisOption.loading = true;
        this.instancesUvAnalysisOption.loading = true;
        const concurrencyParams = _.cloneDeep(params);
        concurrencyParams.report_name = this.instancesPvAnalysisOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(concurrencyParams).then(async (data) => {
            this.instancesPvAnalysisOption.Updated = data.data_date;
            this.instancesUvAnalysisOption.Updated = data.data_date;
            this.concurrencyUserDetailsOption.Updated = data.data_date;
            this.instancesPvAnalysisOption.noData = data.data_detail.length === 0;
            this.instancesUvAnalysisOption.noData = data.data_detail.length === 0;
            if (this.instancesPvAnalysisOption.noData)
                return;
            console.log(data.data_detail);
            // 动态生成columns
            const dynamicColumns = await this.getConcurrencyPvUvTableColumns(data.data_detail[0]);
            this.instancesPvAnalysisOption.tableOptions.columns = dynamicColumns;
            this.instancesUvAnalysisOption.tableOptions.columns = dynamicColumns;
            this.instancesPvAnalysisOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.TOTAL_COUNT);
            this.instancesUvAnalysisOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
            const params = {
                data,
                dataSet: CompanyDataAnalysisDataSet.TOTAL_COUNT,
                sortList: Object.keys(data.data_detail[0]),
                colorList: searchColor,
                columns: dynamicColumns,
            };
            this.instancesPvAnalysisOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            const uvOptionParams = {
                ...params,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
            };
            this.instancesUvAnalysisOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(uvOptionParams);
        }).finally(() => {
            this.instancesPvAnalysisOption.loading = false;
            this.instancesUvAnalysisOption.loading = false;
        });
    }
    concurrencyUserDetailsConfigInit() {
        this.concurrencyUserDetailsOption.reportName = CompanyDataAnalysisKeyType.CONCURRENCY;
        this.concurrencyUserDetailsOption.title = this.i18n.t('backoffice.company.dataAnalysis.concurrencyDetail');
        this.concurrencyUserDetailsOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeight;
        this.concurrencyUserDetailsOption.tableOptions.paginationOptions.enabled = true;
        this.concurrencyUserDetailsOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.concurrencyUserDetailsOption.canChangeViewType = false;
        this.concurrencyUserDetailsOption.viewType = CompanyDataAnalysisViewType.Table;
        this.concurrencyUserDetailsOption.canCollapse = false;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user: this.i18n.t('backoffice.company.dataAnalysis.user'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.userConcurrencyPv'),
        };
        this.concurrencyUserDetailsOption.tableFields = [
            { label: labels.date, field: 'event_date', width: '120px', checked: true, fixed: GoodTableColumnFixedType.LEFT },
            { label: this.i18n.t('backoffice.company.dataAnalysis.User'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.userConcurrencyPv'), field: 'concurrency_pv', width: '300px', checked: true },
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true }
        ];
        this.concurrencyUserDetailsOption.tableOptions.columns = this.concurrencyUserDetailsOption.tableFields;
    }
    async getConcurrencyUserDetailsData(params) {
        let concurrencyDetailParams = _.cloneDeep(params);
        this.concurrencyUserDetailsOption.loading = true;
        // 先获取字段设置
        this.concurrencyUserDetailsOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.concurrencyUserDetailsOption.reportName, this.concurrencyUserDetailsOption.tableFields);
        concurrencyDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.concurrencyUserDetailsOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivilegesSummary(concurrencyDetailParams).then(data => {
            this.concurrencyUserDetailsOption.noData = data.iTotalRecords === 0;
            this.concurrencyUserDetailsOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.concurrencyUserDetailsOption.tableOptions.totalRecords = data.iTotalRecords;
            this.concurrencyUserDetailsOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.concurrencyUserDetailsOption.tableOptions.rows = makeConcurrencyUserDetailsTableRows(data.aaData);
        }).catch(() => {
            this.concurrencyUserDetailsOption.noData = true;
        }).finally(() => {
            this.concurrencyUserDetailsOption.loading = false;
        });
    }
    getConcurrencyUserDetailsUsageDownload(params) {
        let concurrencyDetailParams = _.cloneDeep(params);
        concurrencyDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.concurrencyUserDetailsOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUsageDownload(concurrencyDetailParams, 'concurrency-data');
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.COMPANY_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        this.newUserPermissionOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = NEW_COMMON_USER;
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeight;
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getUserPermissionTableColumns();
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            const params = {
                data,
                dataSet: CompanyDataAnalysisDataSet.USER_COUNT,
                sortList: productSoreList,
                colorList: productColor,
                columns: this.companyDataAnalysisService.getUserPermissionTableColumns(),
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getStackBarCharOption(params);
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getAnalysisTableRows(data.data_detail, CompanyDataAnalysisDataSet.USER_COUNT);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.COMPANY_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.USER);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.USER);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    kickedOutBySelfConfigInit() {
        this.kickedOutBySelfOption.reportName = 'kicked_out_report';
        this.kickedOutBySelfOption.title = this.i18n.t('backoffice.company.dataAnalysis.kickedOutBySelf');
        this.kickedOutBySelfOption.canCollapse = false;
        this.kickedOutBySelfOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.kickedOutBySelfOption.canChangeViewType = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.kickedOutBySelfPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.kickedOutBySelfUv'),
        };
        this.kickedOutBySelfOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.kickedOutBySelfOption.chartId = KICKED_OUT_BY_SELF_ANALYSIS;
        this.kickedOutBySelfOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.kickedOutBySelfOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    kickedOutByOthersConfigInit() {
        this.kickedOutByOthersOption.reportName = 'kicked_out_report';
        this.kickedOutByOthersOption.title = this.i18n.t('backoffice.company.dataAnalysis.kickedOutByOthers');
        this.kickedOutByOthersOption.canCollapse = false;
        this.kickedOutByOthersOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.kickedOutByOthersOption.canChangeViewType = true;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.kickedOutByOthersPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.kickedOutByOthersUv'),
        };
        this.kickedOutByOthersOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.kickedOutByOthersOption.chartId = KICKED_OUT_BY_OTHERS_ANALYSIS;
        this.kickedOutByOthersOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.kickedOutByOthersOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
    }
    getKickedOutData(params) {
        this.kickedOutBySelfOption.loading = true;
        this.kickedOutByOthersOption.loading = true;
        const kickedOutParams = _.cloneDeep(params);
        kickedOutParams.report_name = 'kicked_out_report';
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(kickedOutParams).then(data => {
            this.kickedOutBySelfOption.Updated = data.data_date;
            this.kickedOutByOthersOption.Updated = data.data_date;
            this.kickedOutUserDetailOption.Updated = data.data_date;
            // 对于kicked_out_report接口，data_detail是特殊格式
            const kickedOutData = data;
            this.kickedOutBySelfOption.noData = kickedOutData.data_detail.length === 0;
            this.kickedOutByOthersOption.noData = kickedOutData.data_detail.length === 0;
            if (!this.kickedOutBySelfOption.noData) {
                // 处理被自己踢出的数据
                const kickedOutBySelfData = kickedOutData.data_detail.map((item) => ({
                    event_date: item.kicked_out_by_self?.event_date || '',
                    total_count: item.kicked_out_by_self?.total_count || 0,
                    user_count: item.kicked_out_by_self?.user_count || 0,
                }));
                // 计算统计数据
                const selfTotalCount = kickedOutBySelfData.reduce((sum, item) => sum + item.total_count, 0);
                const selfUserCount = kickedOutBySelfData.reduce((sum, item) => sum + item.user_count, 0);
                const selfStatistics = {
                    total_count: selfTotalCount,
                    user_count: selfUserCount,
                    key: 'kickedOutBySelf',
                };
                this.kickedOutBySelfOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(selfStatistics);
                // 创建表格数据
                this.kickedOutBySelfOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, 'kicked_out_by_self');
                const kickedOutBySelfOptionParams = {
                    data: data.data_detail,
                    total_count: this.kickedOutBySelfOption.statistics[0].label,
                    user_count: this.kickedOutBySelfOption.statistics[1].label,
                    key: 'kicked_out_by_self',
                };
                // 创建简单的柱状图选项
                this.kickedOutBySelfOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(kickedOutBySelfOptionParams);
                // 处理被他人踢出的数据
                const kickedOutByOthersData = kickedOutData.data_detail.map((item) => ({
                    event_date: item.kicked_out_by_others?.event_date || '',
                    total_count: item.kicked_out_by_others?.total_count || 0,
                    user_count: item.kicked_out_by_others?.user_count || 0,
                }));
                // 计算统计数据
                const othersTotalCount = kickedOutByOthersData.reduce((sum, item) => sum + item.total_count, 0);
                const othersUserCount = kickedOutByOthersData.reduce((sum, item) => sum + item.user_count, 0);
                const othersStatistics = {
                    total_count: othersTotalCount,
                    user_count: othersUserCount,
                    key: 'kickedOutByOthers',
                };
                this.kickedOutByOthersOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(othersStatistics);
                // 创建表格数据
                this.kickedOutByOthersOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, 'kicked_out_by_others');
                const kickedOutByOthersOptionParams = {
                    data: data.data_detail,
                    total_count: this.kickedOutByOthersOption.statistics[0].label,
                    user_count: this.kickedOutByOthersOption.statistics[1].label,
                    key: 'kicked_out_by_others',
                };
                // 创建简单的柱状图选项
                this.kickedOutByOthersOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(kickedOutByOthersOptionParams);
            }
        }).catch(() => {
            this.kickedOutBySelfOption.noData = true;
            this.kickedOutByOthersOption.noData = true;
        }).finally(() => {
            this.kickedOutBySelfOption.loading = false;
            this.kickedOutByOthersOption.loading = false;
        });
    }
    kickedOutUserDetailConfigInit() {
        this.kickedOutUserDetailOption.reportName = 'kicked_out_report';
        this.kickedOutUserDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.kickedOutUserDetail');
        this.kickedOutUserDetailOption.canCollapse = false;
        this.kickedOutUserDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.kickedOutUserDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.kickedOutUserDetailOption.tableOptions.paginationOptions.enabled = true;
        this.kickedOutUserDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.kickedOutUserDetailOption.canChangeViewType = false;
        this.kickedOutUserDetailOption.tableFields = [
            { label: this.i18n.t('backoffice.company.dataAnalysis.user'), field: CompanyDataAnalysisEventKey.USER_INFO, width: '280px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.jobTtitle'), field: CompanyDataAnalysisEventKey.JOB_TITLE, width: '200px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.permission'), field: CompanyDataAnalysisEventKey.PERMISSIONS, width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.kickedOutBySelf'), field: 'kicked_out_by_self', width: '240px', checked: true },
            { label: this.i18n.t('backoffice.company.dataAnalysis.kickedOutByOthers'), field: 'kicked_out_by_others', width: '240px', checked: true },
            { label: this.i18n.t('backoffice.account.userId'), field: CompanyDataAnalysisEventKey.USER_ID, width: '300px', checked: true }
        ];
        this.kickedOutUserDetailOption.tableOptions.columns = this.kickedOutUserDetailOption.tableFields;
    }
    async getKickedOutUserDetailData(params) {
        let kickedOutUserDetailParams = _.cloneDeep(params);
        this.kickedOutUserDetailOption.loading = true;
        kickedOutUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.kickedOutUserDetailOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisKickedOutSummary(kickedOutUserDetailParams).then(data => {
            this.kickedOutUserDetailOption.noData = data.iTotalRecords === 0;
            this.kickedOutUserDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.kickedOutUserDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.kickedOutUserDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.kickedOutUserDetailOption.tableOptions.rows = makeKickedOutUserDetailTableRows(data.aaData);
        }).catch(() => {
            this.kickedOutUserDetailOption.noData = true;
        }).finally(() => {
            this.kickedOutUserDetailOption.loading = false;
        });
    }
    getKickedOutUserDetailUsageDownload(params) {
        let kickedOutUserDetailParams = _.cloneDeep(params);
        kickedOutUserDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.kickedOutUserDetailOption.reportName);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisKickedOutDownload(kickedOutUserDetailParams, 'kicked_out_report');
    }
    initData(params) {
        Promise.all([
            this.getConcurrencyData(params),
            // this.getConcurrencyUserDetailsData(params),
            this.getNewUserPermissionDetailsData(params),
            this.getNewUserPermissionData(params),
            this.getKickedOutData(params)
        ]);
    }
};
CompanyUserDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.CompanyQueriesService)),
    __param(3, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], CompanyUserDataAnalysisService);
export { CompanyUserDataAnalysisService };
